import { render } from "./admin-exceptions.vue?vue&type=template&id=1d77e294&scoped=true"
import script from "./admin-exceptions.vue?vue&type=script&lang=js"
export * from "./admin-exceptions.vue?vue&type=script&lang=js"

import "./admin-exceptions.vue?vue&type=style&index=0&id=1d77e294&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d77e294"]])

export default __exports__